import { createFileRoute, redirect } from '@tanstack/react-router'
import { model } from '@/lib/queries/models'
import { rosterEntry } from '@/lib/queries/roster-entries'
import { decodeId, encodeId } from '@/lib/short-uuid'
import { TalentDetailPage } from '@/features/workspaces/roster/talent-detail-page'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/roster/$talentId'
)({
  params: {
    parse: (rawParams: { talentId: string }) => {
      try {
        return { talentId: decodeId(rawParams.talentId) }
      } catch {
        return { talentId: rawParams.talentId }
      }
    },
    stringify: (params: { talentId: string }) => ({
      talentId: encodeId(params.talentId),
    }),
  },
  staticData: { layout: 'fluid' },
  loader: async ({ context, params }) => {
    const { queryClient } = context
    const [talent, roster] = await Promise.all([
      queryClient.query(model.findOneWithShots(params.talentId)),
      queryClient.query(rosterEntry.findManyByWorkspace(params.workspaceId)),
    ])

    if (!talent || !roster.some((entry) => entry.model_id === talent.id)) {
      throw redirect({
        to: '/org/$orgId/workspace/$workspaceId/roster',
        params: { orgId: params.orgId, workspaceId: params.workspaceId },
        replace: true,
      })
    }
  },
  component: TalentDetailRouteComponent,
})

function TalentDetailRouteComponent() {
  const { orgId, workspaceId, talentId } = Route.useParams()
  return (
    <TalentDetailPage
      orgId={orgId}
      workspaceId={workspaceId}
      talentId={talentId}
    />
  )
}
